import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface TitleProps {
  title: string
  icon: React.ComponentProps<typeof Icon.Large>['icon']
}
const Title = ({ title, icon }: TitleProps) => {
  return (
    <h2>
      <Box flexDirection="row" gap="s12">
        <Icon.Large icon={icon} />
        <Text.Header1>{title}</Text.Header1>
      </Box>
    </h2>
  )
}

export default Title
